// eslint-disable-next-line no-restricted-syntax
import { localPoint } from '@visx/event';
import { useCallback, useContext, useEffect } from 'react';
import EventEmitterContext from '../context/EventEmitterContext';

/** The react PointerEvent or FocusEvent. */

/**
 * Hook for optionally subscribing to a specified EventType,
 * and returns emitter for emitting events.
 */
export default function useEventEmitter( /** Type of event to subscribe to. */
eventType,
// Event filter can be an array which is problematic if we make a depedency.
eventFilter, /** Handler invoked on emission of EventType event.  */
handler) {
  const emitter = useContext(EventEmitterContext);
  const eventFilterStr = [].concat(eventFilter || []).join('|');
  if (!emitter) throw new Error('useEventEmitter/useChartEvents must be used within a EventEmitterContext!');
  // wrap emitter.emit so we can enforce stricter type signature
  const emit = useCallback((event, eventData) => {
    // Doing an includes check will be a problem for a few events. (drag, dragstart).
    // Those should be the only ones though so this is fine.
    if (!eventFilterStr || eventFilterStr.includes(event.type)) {
      if (emitter) {
        emitter.emit(eventType, {
          event,
          svgPoint: event ? localPoint(event) : null,
          eventData
        });
      }
    }
  }, [emitter, eventType, eventFilterStr]);
  useEffect(() => {
    if (emitter && eventType && handler) {
      const filteredHandler = params => {
        if (!eventFilterStr || eventFilterStr.includes(params.event.type)) {
          handler(params);
        }
      };
      emitter.on(eventType, filteredHandler);
      return () => emitter === null || emitter === void 0 ? void 0 : emitter.off(eventType, filteredHandler);
    }
    return undefined;
  }, [emitter, eventType, handler, eventFilterStr]);
  return emit;
}